// @ts-nocheck
import { toast } from 'react-toastify';

export const notify = {
    success: (msg) => toast.success(msg || 'OK'),
    error: (msg) => toast.error(msg || 'Error'),
    info: (msg) => toast.info(msg),
    warn: (msg) => toast.warn(msg),
    apiError: (err, fallback = 'Something went wrong') => {
        const msg =
            err?.response?.data?.message ||
            err?.message ||
            fallback;
        toast.error(msg);
    },
};

export default notify;
